// screens/StickyFooter.js
import SVG from "react-inlinesvg";
import Navlink from "../Navlink";
import textLanguage from "@/constants/textLanguage";
import styles from "./footer.module.scss";
// import siteInfo from "@/constants/siteInfo";

const StickyAdSlot320x50 = dynamic(() =>
  import("@/component/Ads/StickyAdSlot320x50")
);
import { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import sendGAEvent from "@/utils/gaEvent";
// import { useRouter } from "next/router";


const StickyFooter = () => {
  const [scrollDirection, setScrollDirection] = useState(null);
  // const router = useRouter();
  // const isMP = router.asPath.includes("madhya-pradesh");
  // const isRJ = router.asPath.includes("rajasthan");
  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction = scrollY > lastScrollY ? "down" : "up";
      if (
        direction !== scrollDirection &&
        (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)
      ) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener("scroll", updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener("scroll", updateScrollDirection); // clean up
    };
  }, [scrollDirection]);
  return (
    <>
      {/* {(isMP||isRJ)&&(scrollDirection==="down")&&<a id="backToNwTak" role="button" href="/" className="fixed border border-black bottom-[4.7rem] shadow-md px-1 left-[25%] flex justify-center items-center h-10 bg-white rounded-full">
          <SVG src="/assets/icons/svg/left.svg"/>
          <span className="mx-1">Back To </span>
            <div className="min-w-[25px]">
              <img
                src={siteInfo.siteLogo}
                className="h-6 w-18 mr-2"
                title="backToHome"
              />
            </div>
      </a>} */}
      <div
        id= "sticky-ad"
        className={`fixed inset-x-0 bottom-[4.2rem] z-[60]`}
      >
        {/* {showStickyAd && ( */}
        
          <StickyAdSlot320x50
            divId="div-gpt-ad-1659435612077-0"
            minHeight="60px"
          />
        
        {/* )} */}
      </div>
      <div
        className={`fixed inset-x-0 bottom-0 bg-white border-t-2 rounded-xl ${
          scrollDirection=="up"?"block":""
        }`}
        style={{zIndex: '500'}}
      >
        <div className="flex justify-evenly items-center max-w-md mx-auto p-2 ">
          {/* Home Icon */}
          <Navlink
            title={textLanguage?.headerStaticMenuText?.home}
            href="/"
            exact={true}
            className="hover:text-primary"
            onClick={() => {
              sendGAEvent({
                eventName: "BottomBar-Home",
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            <div className="flex flex-col items-center">
              <div className="min-w-[53px] min-h-[25px] px-4 hover:text-primary">
                <SVG
                  src="/assets/icons/svg/home.svg"
                  className="h-5 w-5 mb-1"
                />
              </div>
              <div className="px-4 hover:text-primary">
                {textLanguage?.headerStaticMenuText?.home}
              </div>
            </div>
          </Navlink>

          {/* politics Icon */}
          {/* <Navlink
            // href={process.env.NEXT_PUBLIC_VISUALSTORY_URL}
            title={textLanguage?.headerStaticMenuText?.read}
            className="hover:text-primary"
            href="/national-news"
            onClick={() => {
              sendGAEvent({
                eventName: "BottomBar-Read",
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            <div className="flex flex-col items-center text-center justify-center">
              <div className="min-w-[53px] min-h-[25px] px-4 hover:text-primary">
                <SVG
                  src="/assets/icons/svg/read.svg"
                  className="h-5 w-5 mb-1"
                />
              </div>
              <div className="px-4 hover:text-primary">
                {textLanguage?.headerStaticMenuText?.read}
              </div>
            </div>
          </Navlink> */}

          {/* tab for stories start */}
         <Navlink
          href="/stories"
          onClick={() => {
            sendGAEvent({
              eventName: "BottomBar-Video",
              pageTitle: document?.title,
              pageLocation: window?.location?.href,
            });
          }}
          title={textLanguage?.headerStaticMenuText?.read}
          className="hover:text-primary w-1/4"
        >
          <div className="flex flex-col items-center">
            <div className="min-w-[53px] min-h-[25px] px-4 hover:text-primary">
              <SVG src="/assets/icons/svg/read.svg" className="h-5 w-5 mb-1" />
            </div>
            <div className="min-w-[53px] min-h-[25px] px-4 hover:text-primary">
              {textLanguage?.headerStaticMenuText?.read}
            </div>
          </div>
        </Navlink>

        {/* tab for stories end */}
          {/* Videos Icon */}
          <Navlink
            href="/videos"
            title={textLanguage?.headerStaticMenuText?.watch}
            className="hover:text-primary"
            onClick={() => {
              sendGAEvent({
                eventName: "BottomBar-Watch",
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            <div className="flex flex-col items-center">
              <div className="min-w-[53px] min-h-[25px] px-4 hover:text-primary">
                <SVG
                  src="/assets/icons/svg/video.svg"
                  className="h-5 w-5 mb-1"
                />
              </div>
              <div className="min-w-[53px] min-h-[25px] px-4 hover:text-primary">
                {textLanguage?.headerStaticMenuText?.watch}
              </div>
            </div>
          </Navlink>
          <Navlink
            // href={process.env.NEXT_PUBLIC_VISUALSTORY_URL}
            title= "राज्य"
            className="hover:text-primary"
            href="/state-news"
            onClick={() => {
              sendGAEvent({
                eventName: "BottomBar-StateNewsClick",
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            <div className="flex flex-col items-center text-center justify-center ">
              <div className="min-w-[30px] min-h-[25px] px-1 hover:text-primary ">
                <SVG
                  src="/assets/icons/svg/global-search.svg"
                  className="h-5 w-5 mb-1"
                />
              </div>
              <div className="px-4 hover:text-primary">
               राज्य
              </div>
            </div>
          </Navlink>

          {/* Business Icon */}
          {/* <Navlink
            title={textLanguage?.headerStaticMenuText?.business}
            href="/business"
            className="hover:text-primary"
          >
            <div className="flex flex-col items-center">
              <div className="min-w-[53px] min-h-[25px] px-4 hover:text-primary">
                <SVG
                  src="/assets/icons/svg/world.svg"
                  className="h-5 w-5 mb-1"
                />
              </div>
              <div className="px-4 hover:text-primary">
                {textLanguage?.headerStaticMenuText?.business}
              </div>
            </div>
          </Navlink> */}
          {/* Shorts Icon */}
          {/* <Navlink
            title={textLanguage?.headerStaticMenuText?.shorts}
            href="/short-videos"
            className="hover:text-primary"
          >
            <div className="flex flex-col items-center">
              <div className="min-w-[53px] min-h-[25px] px-4 hover:text-primary">
                <SVG
                  src="/assets/icons/svg/video-clip.svg"
                  className="h-5 w-5 mb-1"
                />
              </div>
              <div className="px-4 hover:text-primary">
                {textLanguage?.headerStaticMenuText?.shorts}
              </div>
            </div>
          </Navlink> */}
        </div>
      </div>
    </>
  );
};

export default StickyFooter;
